import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

document.addEventListener("DOMContentLoaded", function(event) {
  document.querySelectorAll('.c-image-gallery__slider-container').forEach((slider) => {

    // init Swiper:
    const swiper = new Swiper(slider, {
      // configure Swiper to use modules
      modules: [Navigation, Pagination, Autoplay],
      pagination: {
        el: '.c-slider-pagination',
        type: 'bullets',
        bulletClass: 'c-slider-pagination__bullet',
        bulletActiveClass: 'c-slider-pagination__bullet--active',
        clickable: true
      },
      navigation: {
        nextEl: '.c-image-gallery__nav-right',
        prevEl: '.c-image-gallery__nav-left',
      },
      centeredSlides: true,
    });

    const swiperAutoplay = parseInt(swiper.el.dataset.autoplay);
    const swiperDelay = parseInt(swiper.el.dataset.delay);

    if (swiperAutoplay === 1) {
      if (swiperDelay > 0) {
        swiper.params.autoplay = {delay: swiperDelay};
        swiper.autoplay.start();
      } else {
        swiper.params.autoplay = {delay: 3000};
        swiper.autoplay.start();
      }
    }

    addSliderEvents(swiper, slider);
  });
});

const addSliderEvents = (swiper, slider) => {
  const imageComponents = document.querySelectorAll('.c-image-gallery .c-image');
  imageComponents.forEach(item => {
    item.addEventListener('click', event => {
      const position = event.currentTarget.dataset.position - 1;
      const container = event.currentTarget.closest('.c-image-gallery');
      const slider = container.querySelector('.c-image-gallery__slider');
      slider.classList.add('c-image-gallery__slider--open');
      swiper.slideTo(position);
    });
  });

  const close = slider.querySelector('.c-image-gallery__slider-close');
  close.addEventListener('click', event => {
    const container = event.currentTarget.closest('.c-image-gallery');
    const slider = container.querySelector('.c-image-gallery__slider');
    slider.classList.remove('c-image-gallery__slider--open');
  });
}